import {
  getMachinesByActivity, unBindMachine, bindMachine, saveMachineActivity, getMachineActivity, getMachineType,
  insertMachineType, updateMachineType, machineSave, machineGet, machineInfo, DelType, MachineDispense, SaveDispense,
  MachineError, MachineErrorList, MachineErrorDel, GetMachinesByScreenSaver, MachineErrorStatus, GetMachineConnect, SetMachineDate, GetMachineRenew, GetMachineReport,
  GetMachineTrack, SaveMachineTrack, SaveMachineLog, GetMachineLogList, MachineListConcise, GetMachineRepair,
  GetMachineDispense, GetAgentDispenseAccount, SaveMachineDispense, SyncMachine, GetMachineLastError,GetMachineTypeGroup
} from '@/api/machine'
export default {
  state: {
    machine: [],
    machine_info: {}
  },
  getters: {
    machine: state => state.machine,
    machine_info: state => state.machine_info
  },
  actions: {
    getMachinesByActivity({ commit }, payload) {
      return new Promise(resolve => {
        getMachinesByActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    unBindMachine({ commit }, payload) {
      return new Promise(resolve => {
        unBindMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    bindMachine({ commit }, payload) {
      return new Promise(resolve => {
        bindMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveMachineActivity({ commit }, payload) {
      return new Promise(resolve => {
        saveMachineActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getMachineActivity({ commit }, payload) {
      return new Promise(resolve => {
        getMachineActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    initMachineInfo({ commit }, payload) {
      commit('SET_MACHINE_INFO', {})
    },
    getType({ commit }, payload) {
      return new Promise(resolve => {
        getMachineType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    insertType({ commit }, payload) {
      return new Promise(resolve => {
        insertMachineType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    updateType({ commit }, payload) {
      return new Promise(resolve => {
        updateMachineType({
          id: payload.id,
          name: payload.name,
          brand: payload.brand,
          type: payload.type,
          is_del: payload.is_del
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    saveMachine({ commit }, payload) {
      return new Promise(resolve => {
        machineSave(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getMachine({ commit }, payload) {
      return new Promise(resolve => {
        machineGet(payload).then(res => {
          commit('SET_MACHINE', res.data.data)
          resolve(res.data)
        })
      })
    },
    machineInfo({ commit }, payload) {
      return new Promise(resolve => {
        machineInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelType({ commit }, payload) {
      return new Promise(resolve => {
        DelType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineDispense({ commit }, payload) {
      return new Promise(resolve => {
        MachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveDispense({ commit }, payload) {
      return new Promise(resolve => {
        SaveDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineError({ commit }, payload) {
      return new Promise(resolve => {
        MachineError(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineErrorDel({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorDel(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineErrorList({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachinesByScreenSaver({ commit }, payload) {
      return new Promise(resolve => {
        GetMachinesByScreenSaver(payload).then(res => {
          commit('SET_MACHINE', res.data)
          resolve(res.data)
        })
      })
    },
    MachineErrorStatus({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorStatus(payload).then(res => {
          commit('SET_MACHINE', res.data)
          resolve(res.data)
        })
      })
    },
    GetMachineConnect({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineConnect(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SetMachineDate({ commit }, payload) {
      return new Promise(resolve => {
        SetMachineDate(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineRenew({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineRenew(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineReport({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineReport(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineTrack({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineTrack(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineTrack({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineTrack(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineLog({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineLogList({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineLogList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineListConcise({ commit }, payload) {
      return new Promise(resolve => {
        MachineListConcise(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineRepair({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineRepair(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineDispense({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAgentDispenseAccount({ commit }, payload) {
      return new Promise(resolve => {
        GetAgentDispenseAccount(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineTypeGroup({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineTypeGroup(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineDispense({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SyncMachine({ commit }, payload) {
      return new Promise(resolve => {
        SyncMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineLastError({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineLastError(payload).then(res => {
          let nameObj = {
            black: "黑色",
            magenta: "红色",
            yellow: "黄色",
            cyan: "青色",
            manual: "手送台",
            tray1: "纸盒1",
            tray2: "纸盒2",
            tray3: "纸盒3",
            tray4: "纸盒4"
          };
          console.log('data', res)

          let data = res.data.data;

          if (!data.id) {
            resolve(res.data)
            return;
          }
          data.tray = JSON.parse(data.tray)
          data.toner = JSON.parse(data.toner)

          let tray = [],
            toner = []
          data.tray.map(item => {
            tray.push({
              name: nameObj[item.split('_')[0]],
              val: parseInt(item.split('_')[1])
            })
          })
          data.toner.map(item => {
            toner.push({
              name: nameObj[item.split('_')[0]],
              val: parseInt(item.split('_')[1])
            })
          })
          data.tray = tray
          data.toner = toner
          // this.state.machine_info = data
          console.log('d',data)
          commit('SET_MACHINE_INFO', data)
        })
      })
    },
  },
  mutations: {
    SET_MACHINE(state, payload) {
      state.machine = payload
    },
    SET_MACHINE_INFO(state, payload) {
      state.machine_info = payload
    }
  }
}
